/**
 * --------------------------------------------------------------------
 * jQuery-Plugin Animate On View
 * Version: 2.0
 *
 * Animate elements into view when scrolled to
 *
 * by Lance Oliver Cummings, lance@glance.ca
 *
 * Requires inview.js
 *
 * --------------------------------------------------------------------
 * Changelog:
 * v 1.0, 13.10.2018
 * v 2.0, 04.02.2021
 *
 * --------------------------------------------------------------------
 */

(function ($) {
  $.fn.showOnView = function (options) {
    var settings = $.extend(
      {
        count: "once",
        breakpoint: "atleast_medium",
      },
      options
    );

    var $this = this;
    var init = true;

    $this.off('inview').removeClass('inview');

    function switchMenu(obj, media) {
      onInit(media[settings.breakpoint] || media.fallback);
    }
    $.subscribe("breakpoints", switchMenu);

    function onInit(desktop) {
      if (init) {
        init = false;

        $this.each(function () {
          var $el = $(this);

          if (settings.count == "everytime" && desktop) {
            $el.on("inview", function (event, isInView) {
              if (isInView) {
                $el.addClass("inview");
              } else {
                $el.removeClass("inview");
              }
            });
          } else {
            $el.one("inview", function (event, isInView) {
              if (isInView) {
                $el.addClass("inview");
              }
            });
          }
        });
      }
    }
  };
})(jQuery);
